/**
 * Temporary shim: WebSocketChatContext (deprecated)
 *
 * Re-exports the transport-agnostic ChatConnectionContext under legacy names
 * to minimize churn. Callers should migrate to ChatConnectionContext.
 */

import React from 'react';
import {
  ChatConnectionProvider,
  useChatConnectionContext,
  useChatTypingStatus,
} from './ChatConnectionContext';
import type { ChatConnectionContextValue as WebSocketChatContextValue } from './ChatConnectionContext';

export type { WebSocketChatContextValue };

export { ChatConnectionProvider };
export const useWebSocketChatContext = useChatConnectionContext;
export const useWebSocketTypingStatus = useChatTypingStatus;

export default undefined as unknown as WebSocketChatContextValue;